export const TASK_STATUS_MAP = {
  0: '全部',
  1: '赴馆',
  2: '预审',
  3: '补价差',
  4: '待办事项',
  5: '客诉预警',
};
export const TASK_STATUS_ENUM = {
  all_0: 0,
  go_1: 1,
  inquiry_2: 2,
  diff_3: 3,
  todo_4: 4,
  warn_5: 5,
};

export const MSG_TYPE = [
  '订单通知',
  '订单通知',
  '订单通知',
  '催单通知',
  '订单通知',
  '客诉预警',
  '催单结果回顾',
];

export const READ_STATUS_MAP = {
  0: '未读',
  1: '已读',
};
export const SEND_MSG_STATUS_MAP = {
  0: '未发送',
  1: '发送失败',
  2: '已发送',
};

export const TASK_LIST_STATUS_MAP = {
  0: '待处理',
  1: '已完成',
};
